module.exports = __webpack_public_path__ + "staticfr/media/translate.d8843e92.svg";